const AUTH_KEYS = ['auth', 'userData', 'auth_token'];
export function clearSession() {
  ['localStorage', 'sessionStorage'].forEach(name => {
    try {
      const storage = window[name];
      Object.keys(storage).forEach(key => {
        if (AUTH_KEYS.includes(key) || key.startsWith('visao-diretor:') || key === '61imoveis_chat_session') {
          storage.removeItem(key);
        }
      });
    } catch { /* Storage may be disabled by browser privacy settings. */ }
  });
}

export function getSessionToken() {
  try {
    const token = localStorage.getItem('auth_token');
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (!Number.isInteger(payload.sessao_versao) || !Number.isFinite(payload.exp) || payload.exp * 1000 <= Date.now()) {
      clearSession();
      window.dispatchEvent(new Event('session-expired'));
      return null;
    }
    return token;
  } catch { clearSession(); return null; }
}

// Only versioned sessions are accepted; old JWTs must authenticate again.
if (!getSessionToken()) clearSession();
